import { SxProps, Theme } from "@mui/material/styles";

const styles: SxProps<Theme> = [
  {
    "& .iframeWrapper, &.iframeWrapper": {
      height: "100%",
      marginBottom: 3,
    },
    "& .infoMessage": {
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 3,
      padding: "12px 24px",
      background: "rgba(0, 255, 0, 0.1)",
      "& p": {
        fontWeight: "500",
        marginLeft: 8,
      },
    },
  },
];

export default styles;
